module.exports = __webpack_public_path__ + "img/img_article5_item_2@2x.ed79fd1f.png";